import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'parental-student-course-session'
const initialState = {
  list: null,
  count: null,
}

export const search = createApiAction('academic/parental/course-session/search', client.search('/api/academic/parent/student/:studentId/course-session-enrollment'))

const sessionSlice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(search.fulfilled, (state, action) => {
      state.list = action.payload
    })
  },
})

export default sessionSlice.reducer
